import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from 'src/app/shared/services/utils/auth.service';
import { StorageRepositoryService } from 'src/app/shared/services/utils/storage.repository.service';
import { GEE_IMAGE_API_BASE_URL, URL_GEO_API } from 'src/environments/environment.prod';

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const storageService = inject(StorageRepositoryService);
  const token = getCookie('XSRF-TOKEN');
  const authToken = storageService.load('authToken', 'local', null);

  const exceptionHosts = [
    URL_GEO_API,
    GEE_IMAGE_API_BASE_URL,
    'api.planet',
    'earthengine',
    'mapbiomas.org'
  ];

  let headers: any = {};

  // Add XSRF Token if exists and not exception host
  if (token && !exceptionHosts.some(host => req.url.includes(host))) {
    headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
  }

  // Add Ngrok Header
  if (req.url.includes('ngrok-free.app')) {
    headers['ngrok-skip-browser-warning'] = 'true';
  }

  // Add Authorization Token
  // Exclude csrf-cookie and login from Authorization header
  if (authToken && !req.url.includes('/sanctum/csrf-cookie') && !req.url.includes('/login') && !exceptionHosts.some(host => req.url.includes(host))) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  // Clone request with new headers
  if (Object.keys(headers).length > 0) {
    req = req.clone({
      setHeaders: headers,
    });
  }

  if (!exceptionHosts.some(host => req.url.includes(host))) {
    req = req.clone({
      withCredentials: true
    });
  }

  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401) {
        authService.handleWithoutAuthentication();
      }
      return throwError(() => err);
    }),
  );
};

function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}
